/**
  mock this to true in order to test logger in unit tests
  Don't show this warning if the flags are still loading
  Explicitly do not throw this warning if we are in a Jest environment, stolen from:
  https://stackoverflow.com/questions/50940640/how-to-determine-if-jest-is-running-the-code-or-not
*/
export const enableLogging = process?.env?.JEST_WORKER_ID === undefined;
